"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeDesignator = void 0;
exports.getLabelForSchematicNode = getLabelForSchematicNode;
exports.ercSeverityToReviewStatus = ercSeverityToReviewStatus;
const common_1 = require("../../drc/converters/common");
Object.defineProperty(exports, "sanitizeDesignator", { enumerable: true, get: function () { return common_1.sanitizeDesignator; } });
const reviews_1 = require("../../reviews");
function getLabelForSchematicNode(uid, elements) {
    const element = elements[uid];
    if (!element)
        return null;
    if (element.part_version_data_cache?.name) {
        return `${element.part_version_data_cache?.name} ${element.label ?? element.uid.substring(0, 4)}`;
    }
    return element.label ?? element.uid;
}
/**
 * Converts ERC severity from problem metadata to ReviewStatus.
 * Defaults to ERROR if no severity specified (backward compatibility).
 */
function ercSeverityToReviewStatus(severity) {
    if (!severity)
        return reviews_1.ReviewStatus.ERROR;
    switch (severity) {
        case "warning":
            return reviews_1.ReviewStatus.WARNING;
        case "error":
            return reviews_1.ReviewStatus.ERROR;
        default:
            return reviews_1.ReviewStatus.ERROR;
    }
}
//# sourceMappingURL=common.js.map